import { create } from 'zustand';

/** "Correct this" on a data answer (#1508, flag on): the thread's composer replies to THAT answer. Kept per composer
 *  draft key (the thread id), beside the per-thread drafts, so each thread's unsent reply keeps its own answer. Nothing
 *  is persisted. */
interface ComposerReplyState {
  /** per draft key: the answer replied to, and a nonce so a second click re-focuses */
  replies: Record<string, { turnId: string; nonce: number }>;
  startReply: (draftKey: string, turnId: string) => void;
  clearReply: (draftKey: string) => void;
  clearReplies: () => void;
}

export const CORRECTION_PREFILL = 'That’s not right: ';

let nonce = 0;
export const useComposerReply = create<ComposerReplyState>((set, get) => ({
  replies: {},
  startReply: (draftKey, turnId) => set({ replies: { ...get().replies, [draftKey]: { turnId, nonce: ++nonce } } }),
  clearReply: (draftKey) => {
    if (!(draftKey in get().replies)) return;
    const { [draftKey]: _gone, ...rest } = get().replies;
    set({ replies: rest });
  },
  clearReplies: () => set({ replies: {} }),
}));
